/** @flow */
import {
  CreateAbsenceTrendsReport,
  CreateAbsenceTrendsReportSuccess,
  CreateAbsenceTrendsReportError,
} from "@modules/reporting/constants/actions";
import * as firstCareIndexReducers from "./reducers";
import initialState from "./state";
import type { FirstCareIndexState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: FirstCareIndexState = initialState, action: Object): FirstCareIndexState => {
  const act = {
    [CreateAbsenceTrendsReport]: firstCareIndexReducers.setLoading,
    [CreateAbsenceTrendsReportSuccess]: firstCareIndexReducers.onCreateAbsenceTrendsReportSuccess,
    [CreateAbsenceTrendsReportError]: firstCareIndexReducers.onAbsenceTrendsReportError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
